<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.8" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />
<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.5" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />

<app-navbar></app-navbar>

<div class="asociate-container">
    <h1>¡Asociate!</h1>
    <p>Registrate en pocos pasos y comenzá a disfrutar de nuestros beneficios.</p>
    
    <div class="boton-centro" style="display: flex; justify-content: center; gap: 20px;">
      <div style="text-align: center;">
        <p style="margin: 0; font-size: 12px;">Personas</p>
        <a href="http://amvtasociate.ddns.net/" target="_blank" rel="noopener noreferrer">
          <button>Asociate Aquí</button>
        </a>
      </div>
      
      <div style="text-align: center;">
        <p style="margin: 0; font-size: 12px;">Empresas</p>
        <a href="http://amvtasociatej.ddns.net/" target="_blank" rel="noopener noreferrer">
          <button>Asociate Aquí</button>
        </a>
      </div>
    </div>
  </div>

<!-- ¿Todavia tienes preguntas? -->
<div *ngIf="!isLoading" class="more-questions">
  <div fxLayout="row" fxLayoutAlign="center start">
      <div fxFlex="800px" fxFlex.lt-lg="90%">
          <h2>¿Todavía tenés preguntas?</h2>
          <p>Escribinos a cualquiera de nuestros canales de comunicación, WhatsApp o E-Mail, y responderemos tu consulta a la brevedad.</p>
      </div>
  </div>
  <div class="elements" fxLayoutAlign="center start">
      <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1000px" fxFlex.lt-lg="90%" fxLayoutGap="80px" fxLayoutGap.lt-md="0px">
          <div fxFlex="50%">
              <div class="element item-phone">
                  <span class="jam jam-viber"></span>
                  <h3> <a href="https://wa.me/543462583388">3462-583388</a></h3>
              </div>

              <div class="element item-email">
                  <span class="jam jam-messages-alt-f"></span>
                  <h3>plazahogar@amvt.com.ar</h3>
              </div>
          </div>
          <div fxFlex="50%">
              <div class="form-container">
                  <h3>Dejanos un mensaje</h3>
                  <mat-form-field appearance="fill">
                      <mat-label>Nombre completo</mat-label>
                      <input [(ngModel)]="contactName" type="text" matInput placeholder="" required />
                      <span matSuffix class="jam jam-user-circle"></span>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                      <mat-label>Correo electrónico</mat-label>
                      <input [(ngModel)]="contactEmail" type="email" matInput placeholder="" required />
                      <span matSuffix class="jam jam-messages-alt"></span>
                  </mat-form-field>
                  <mat-form-field appearance="fill">
                      <mat-label>Mensaje</mat-label>
                      <textarea [(ngModel)]="contactMessage" matInput rows="4" required minlength="10" maxlength="1500"></textarea>
                  </mat-form-field>
                  <re-captcha style="display: inline-block;"
                  name="captcha"
                  (resolved)="resolved($event)"
                  required
                  siteKey="6LeLX9AZAAAAAHAgXE8Z1R0alnrbqy3olDXbYEws">
                  </re-captcha>

                 <button mat-button type="submit" (click)="onClickContact()" [disabled]="!captchaResolved">ENVIAR MENSAJE</button>
                </div>
          </div>
      </div>
  </div>
</div>

<app-footer></app-footer>
